module.exports = __webpack_public_path__ + "img/withdrawal_x2.388de58a.png";